
import HomeBanner from '@/components/HomeBanner.vue'
import HomeButton from '@/components/HomeButton.vue'
import HomeImageSlider from '@/components/HomeImageSlider.vue'
import HomeRow from '@/components/HomeRow.vue'
import store from '@/store'
import { ref } from 'vue'

const pwaConfig = ref<any>({})

const hideButtonLayout = (context: any) => {
  context.$emit('hide');
}

const processButtonClick = (command: string, context: any) => {
  const buttonCommands: { [key: string]: () => void } = {
    'map': () => hideButtonLayout(context),
  }

  if (buttonCommands[command]) {
    buttonCommands[command]();
  } else {
    console.error('Unknown home button command: ' + command);
  }
}

export default {
  name: 'ButtonLayout',
  components: {
    HomeBanner,
    HomeButton,
    HomeImageSlider,
    HomeRow,
  },
  methods: {
    handleButton1Click() {
      console.log('Button 1 clicked')
      // Add your button1 click handling logic here
    },
    handleButton2Click() {
      console.log('Button 2 clicked')
      // Add your button2 click handling logic here
    },
    handleButton3Click() {
      console.log('Button 3 clicked:', pwaConfig.value.button_3_pref)
      processButtonClick(pwaConfig.value.button_3_pref, this)
    },
    handleButton4Click() {
      console.log('Button 4 clicked:', pwaConfig.value.button_4_pref)
      processButtonClick(pwaConfig.value.button_4_pref, this)
    },
    handleButton5Click() {
      console.log('Button 5 clicked:', pwaConfig.value.button_5_pref)
      processButtonClick(pwaConfig.value.button_5_pref, this)
    },
  },
  computed: {
    backgroundPhoto(): string {
      return pwaConfig?.value?.background_photo || ''
    },
    button1(): string {
      return pwaConfig?.value?.button_1 || ''
    },
    button2(): string {
      return pwaConfig?.value?.button_2 || ''
    },
    button3(): string {
      return pwaConfig?.value?.button_3 || ''
    },
    button4(): string {
      return pwaConfig?.value?.button_4 || ''
    },
    button5(): string {
      return pwaConfig?.value?.button_5 || ''
    },
  },
  setup() {
    store.getPwaConfig().then(data => pwaConfig.value = data)
  }
}
